import { RouterProvider } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from '@/features/auth';
import { LanguageProvider } from '@/features/i18n';
import { queryClient } from '@/lib/queryClient';
import { router } from '@/app/routes';

// Simple App - like other-project (no complex logic)
function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <LanguageProvider>
        <AuthProvider>
          <RouterProvider router={router} />
        </AuthProvider>
      </LanguageProvider>
    </QueryClientProvider>
  );
}

export default App;
